module["exports"] = ["майдан"];